import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";
import "./Team.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

const Team = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  const sumitUrl =
    "https://res.cloudinary.com/dsbwqmbhy/image/upload/v1735652927/sumit_3_ec4jsc.jpg";
  const ashutoshUrl =
    "https://res.cloudinary.com/dsbwqmbhy/image/upload/v1735653200/ashutosh_1_rldp1c.jpg";

  return (
    <>
      <Navbar />
      <div className="container my-5">
        {/* Sumit Section */}
        <div className="row align-items-center bg-light shadow rounded mb-5 p-4">
          <div className="col-md-6 text-center mb-4 mb-md-0">
            <img
              src={sumitUrl}
              className="rounded-circle shadow-sm team-img"
              alt="Sumit Brahamchari"
              data-aos="flip-left"
              draggable="false"
            />
          </div>
          <div className="col-md-6">
            <h3 className="fw-bold text-primary">Sumit Brahamchari</h3>
            <p className="text-muted mb-1">
              <strong>Designation:</strong> Principal
            </p>
            {/* <p className="text-muted mb-1">
              <strong>Qualification:</strong> B.A. in Economics
            </p> */}

            <p className="text-secondary">
              <br />
              Dear Students, Parents, and Esteemed Guests,
              <br /> <br />
              It is a privilege to welcome you to Shine International School, a
              place where learning transcends classrooms and becomes an
              enriching journey of discovery and growth. Our mission is to
              provide a nurturing environment where students are empowered to
              explore their interests, develop their talents, and achieve
              academic excellence. As the Principal, I am committed to upholding
              our school’s values and fostering an atmosphere of inclusivity,
              respect, and innovation. Together, let us continue to create an
              inspiring educational experience that prepares our students to be
              thoughtful leaders and responsible global citizens.
            </p>
          </div>
        </div>

        {/* Ashutosh Section */}
        <div className="row align-items-center bg-light shadow rounded p-4">
          <div className="col-md-6 order-md-2 text-center mb-4 mb-md-0">
            <img
              src={ashutoshUrl}
              className="rounded-circle shadow-sm team-img"
              alt="Ashutosh"
              data-aos="flip-right"
              draggable="false"
            />
          </div>
          <div className="col-md-6 order-md-1">
            <h3 className="fw-bold text-primary">Ashutosh Tiwari</h3>
            <p className="text-muted mb-1">
              <strong>Designation:</strong> Director
            </p>
            {/* <p className="text-muted mb-1">
              <strong>Qualification:</strong> M.Sc. in Mathematics
            </p> */}
            <p className="text-secondary">
              <br />
              Dear Students, Parents, and Visitors,
              <br />
              <br />
              Welcome to Shine International School, where education is not just
              about acquiring knowledge but about fostering a passion for
              lifelong learning. Our vision is to nurture young minds into
              becoming well-rounded individuals who are ready to embrace the
              challenges of the future with confidence and integrity. Together,
              as a community, let us inspire, support, and empower our students
              to reach new heights and make a positive impact on the world.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Team;
